/** Picks the knowledge-page backend: mock (default) or `/api/v1/ai/kb` (same origin/session as ../index.ts). */
import { useMock } from '../index'
import { HttpKbApi } from './http'
import { MockKbApi } from './mock'
import type { KbApi } from './types'

let current: KbApi | null = null

export function getKbApi(): KbApi {
  if (!current) {
    const base = (import.meta.env.VITE_API_BASE ?? '').trim()
    current = useMock ? new MockKbApi() : new HttpKbApi(base)
  }
  return current
}

/** Tests inject their own backend. */
export function setKbApi(api: KbApi | null): void {
  current = api
}

export type * from './types'
